import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Toasted from "vue-toasted";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import VTooltip from "v-tooltip";
import VSelect from "vue-select";
import { ClientTable } from "vue-tables-2";
import ToggleButton from "vue-js-toggle-button";
import DiceAPI from "./apis/DiceAPI";
import AtlasAPI from "./apis/AtlasAPI";
import HermesAPI from "./apis/HermesAPI";
import fr from "./i18n/fr";
import colors from "./helpers/colors";
import ErrorHelper from "./helpers/Error";
import Config from "../config";
import i18n from "./i18n";
import store from "./store";
import "./vee-validate";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "vue-select/src/scss/vue-select.scss";
import "glyphicons-only-bootstrap/css/bootstrap.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/scss/icons.scss";
import "./assets/scss/style.scss";

if (Config.sentry.enabled) {
    Sentry.init({
        dsn: `https://${Config.sentry.key}@sentry.io/${Config.sentry.projectId}`,
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    });
}

Vue.config.productionTip = false;
Vue.use(Toasted, {
    position: "bottom-right",
    duration: 3000,
    iconPack: "fontawesome",
});
Vue.use(VTooltip, { defaultContainer: "body" });
Vue.use(ToggleButton);
Vue.component("VSelect", VSelect);

Vue.use(ClientTable, { texts: fr.VueClientTable }, false, "bootstrap4");

Vue.use(AtlasAPI);
Vue.use(DiceAPI);
Vue.use(HermesAPI);

Vue.mixin({
    data() {
        return {
            $colors: colors,
        };
    },
    methods: {
        $displayError(err) {
            if (ErrorHelper.isAPIError(err)) {
                if (err.response.data.statusCode === 400) {
                    this.$toasted.error(this.$t("Error.badRequest"), { icon: "times" });
                } else if (err.response.data.statusCode === 401) {
                    this.$store.dispatch("user/logout", { toasted: false });
                    this.$toasted.error(this.$t("Error.unauthorized"), { icon: "times" });
                } else if (err.response.data.statusCode === 429) {
                    this.$toasted.error(this.$t("Error.tooManyRequests"), { icon: "times" });
                } else if (err.response.data.statusCode === 500) {
                    this.$toasted.error(this.$t("Error.serverError"), { icon: "times" });
                }
            }
        },
    },
    computed: {
        $customerSelected() {
            if (this.customers === undefined) {
                return undefined;
            } else {
                return this.customers.find(customer => customer.selected);
            }
        },
        $allCustomersSelected() {
            if (this.customers === undefined) {
                return undefined;
            } else {
                return this.$customerSelected.id === 0;
            }
        },
        $firstSectionPath() {
            const url = this.$route.path;
            const matches = url.match("[a-z]+");
            return matches !== null ? matches[0] : "";
        },
    },
});

new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount("#app");